// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZxGzi","disabled":"styles_disabled__f_bzI"};